/* ⚠️ GENERATED from app/services/avatarStyleApply.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/avatarStyleApply.ts — a described outfit becomes a spec.
//
// 🟢 ONE RULE, BOTH CLIENTS, AND NOTHING IT DID NOT SAY. Only the slots the
//    model actually filled are changed; a style it invented, a colour it could
//    not give, or a hair field it was not asked about leaves that part of the
//    avatar exactly as it was. That is what makes the box safe to type into: the
//    worst case is that nothing moves.
//
// 🟥 AND IT LIVES HERE, NOT IN avatarStyle.ts, for the same reason
//    avatarFaceApply.ts exists: the schema is imported by the SERVER, and the
//    server must not pull in the whole catalogue to answer one request.

import { outfitIsUsable } from './avatarStyle';
import { normalizeSpec, TOP_STYLES, BOTTOM_STYLES, SHOE_STYLES, HAT_STYLES, HAIR_STYLES } from './avatarKit';
const keep = (p, style, color, styles) => ({
  style: style && styles.includes(style) ? style : p.style,
  color: color || p.color
});

/** Fold a described outfit into a spec. */
export function applyOutfit(spec, reading) {
  const s = normalizeSpec(spec);
  if (!outfitIsUsable(reading)) return s;
  const r = reading;
  const next = {
    ...s
  };
  next.top = keep(s.top, r.top, r.topColor, TOP_STYLES);
  next.bottom = keep(s.bottom, r.bottom, r.bottomColor, BOTTOM_STYLES);
  next.shoes = keep(s.shoes, r.shoes, r.shoesColor, SHOE_STYLES);
  if (r.hat === 'none') next.hat = null;else if (r.hat && HAT_STYLES.includes(r.hat)) {
    next.hat = {
      style: r.hat,
      color: r.hatColor || s.hat && s.hat.color || '#3E434B'
    };
  }
  /* 🟢 hair only when the words were about hair — otherwise "black jacket"
     would quietly dye someone's hair black, which is not what they asked. */
  if (r.changeHair && r.hair) {
    next.hair = {
      style: HAIR_STYLES.includes(r.hair) ? r.hair : s.hair.style,
      color: r.hairColor || s.hair.color
    };
  }
  return normalizeSpec(next);
}
